import React, { FunctionComponent, useState } from 'react'
import { IWorkroom } from 'Frontend/scripts/models/workrooms.model'
import { joinWorkroom, leaveWorkroom } from 'Frontend/scripts/services/workrooms.service'
import { Button } from 'react-bootstrap'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { useTranslation } from 'react-i18next'

interface WorkroomsListingProps {
  workroom: IWorkroom
}

const WorkroomsListItem: FunctionComponent<WorkroomsListingProps> = ({ workroom }) => {
  const [isMember, setIsMember] = useState<boolean>(workroom?.isMember)
  const { t } = useTranslation()

  const userJoinWorkroom = (workRoomId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      joinWorkroom(token.csrfToken, workRoomId).then(() => {
        setIsMember(true)
      })
    })
  }

  const userLeaveWorkroom = (workRoomId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      leaveWorkroom(token.csrfToken, workRoomId).then(() => {
        setIsMember(false)
      })
    })
  }

  return (
    <>
      <div className="livstecknet__listing-content-row flex-column" key={`result-${workroom.id}`}>
        <div className="d-flex justify-content-between gap-3">
          <h3 className="livstecknet__listing-content-row-link">
            <a href={workroom.url} className="">
              {workroom.name}
            </a>
          </h3>
          {isMember ? (
            <Button variant="dark" className="flex-shrink-0" onClick={() => userLeaveWorkroom(workroom.id)}>
              {t('leave')}
            </Button>
          ) : (
            <Button variant="secondary" className="flex-shrink-0" onClick={() => userJoinWorkroom(workroom.id)}>
              {t('join')}
            </Button>
          )}
        </div>
        {workroom.workroomCategoryId === 1 || workroom.workroomCategoryId === 0}{' '}
        {<span>{workroom.workroomCategoryId === 1 ? 'Regionalt' : 'Nationellt'}</span>}
        <div className="d-flex gap-2">
          {workroom.isWorkroomAdministrator && (
            <span className="badge rounded-pill bg-secondary workrooms__bagde-role">{t('administrator')}</span>
          )}
          {workroom.isWorkroomOwner && (
            <span className="badge rounded-pill bg-secondary workrooms__bagde-role">{t('owner')}</span>
          )}
        </div>
      </div>
    </>
  )
}
export default WorkroomsListItem
